import { GRAFANA_DASHBOARD_URL } from 'configs';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import './AdministrationDashboardPage.scss';

const dashboardUrl = GRAFANA_DASHBOARD_URL?.trim() ?? '';

export const AdministrationDashboardPage: FC = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'administrationDashboardPage'
  });

  const iframeTitle = useMemo(() => t('iframeTitle'), [t]);

  if (!dashboardUrl) {
    return (
      <div className="administration-dashboard-page">
        <p className="administration-dashboard-page__unconfigured">
          {t('unconfigured')}
        </p>
      </div>
    );
  }

  return (
    <div className="administration-dashboard-page">
      <div className="administration-dashboard-page__toolbar">
        <a
          href={dashboardUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="administration-dashboard-page__open-link"
        >
          {t('openInNewTab')}
        </a>
      </div>
      <iframe
        className="administration-dashboard-page__frame"
        src={dashboardUrl}
        title={iframeTitle}
      />
    </div>
  );
};
